import { render, staticRenderFns } from "./app-qr-view.vue?vue&type=template&id=2a4746b2&scoped=true"
import script from "./app-qr-view.vue?vue&type=script&lang=js"
export * from "./app-qr-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4746b2",
  null
  
)

export default component.exports